import { post, get, geted, wordpost } from '../network/index.js'

//团购订单管理 - 订单列表
const getGroupOrderList = data => {
  return post('/mercWebi/order/getGroupOrderList', data)
}

//团购订单管理 - 订单详情
const queryOrderDetail = data => {
  return post('/mercWebi/order/getOrderDetail', data)
}

//团购订单管理 - 订单状态数量
const getSumOrdserStatus = data => {
  return post('/mercWebi/order/getSumOrdserStatus', data)
}

//  查询劵码的预约使用记录
const queryCodeBookedInfo = data => {
  return post('/mercWebi/subscribeOrder/queryCodeBookedInfo', data)
}

//团购订单退款
const refundGroupOrder = data => {
  return post('/mercWebi/order/refundGroupOrder', data)
}
// 商家后台 - 查询订单支付信息
const queryOrderPayList = data => {
  return post('/mercWebi/order/queryOrderPayList', data)
}
// 商家后台 --> 新增家政订单备注
const insertOrderRemarke = data => {
  return post('/mercWebi/order/insertOrderRemarke', data)
}
// 商家后台 --> 修改家政订单备注
const modifyOrderRemarke = data => {
  return post('/mercWebi/order/modifyOrderRemarke', data)
}
// 商家后台 --> 删除家政订单备注
const deleteOrderRemarke = data => {
  return post('/mercWebi/order/deleteOrderRemarke', data)
}

// 商家后台 --> 导出团购订单列表
const downloadGroupOrderList = data => {
  return post('/mercWebi/order/downloadGroupOrderList', data)
}
//商品订单列表
const queryTakeoutList = data => {
  return post('/mercWebi/order/getTakeOutOrderList', data)
}
//商品订单列表 - 指派跑腿员
const addWorker = data => {
  return post('/webi/takeOutOrder/addWorker', data)
}
const queryTakeOutSums = data => {
  return post('/mercWebi/order/getSumOrdserStatus', data)
}
//估价订单列表
const evalOrderList = data => {
  return post('/eval-price-order/page', data)
}
const evalOrderStatusCount = data => {
  return get('/eval-price-order/status-count-list', data)
}
//估价交易记录
const evalTradeRecord = data => {
  return post('/eval-price-order/trade-record', data)
}
//估价 终估
const finalEval = data => {
  return post('/eval-price-order/final-eval', data)
}
//估价 初估
const firstEval = data => {
  return post('/eval-price-order/first-eval', data)
}
//估价订单详情
const evalOrderDetail = data => {
  return geted('/eval-price-order/detail', data)
}
//洗护订单列表
const queryWashOrderList = data => {
  return post('/mercWebi/order/queryWashOrderList', data)
}
//洗护订单美团失败列表
const queryWashMeiTuanOrderList = data => {
  return post('/mercWebi/order/queryWashOrderByStatusList', data)
}
//洗护订单详情
const queryWashOrderDetail = data => {
  return post('/mercWebi/order/queryWashOrderDetail', data)
}
//美团订单-重新推送
const updateorderfulfillinfo = data => {
  return post('/dzopen/book/updateorderfulfillinfo', data)
}
//洗护订单-修改地址
const washOrderUpdateAddress = data => {
  return post('/mercWebi/order/updateAddress', data)
}
// 获取跑腿员列表
const queryList = data => {
  return post('/webi/webSysWorkerInfo/queryList', data)
}
//区域管理 - 归属分站
const queryDownList = data => {
  return post('/webi/station/queryDownList', data)
}
//订单列表 - 拣货并导出
const pickingOrderInfo = data => {
  return get('/webi/webOrder/pickingOrderInfo', data)
}
// 洗护订单导出
const excelWashOrderList = data => {
  return wordpost('/mercWebi/order/excelWashOrderList', data)
  // return post('/mercWebi/order/excelWashOrderList', data)
}
// 回收订单--列表
const recoveryList = data => {
  return post('/recovery-order/page', data)
}
// 回收订单--回收订单详情
const recoveryDetail = data => {
  return geted('/recovery-order/detail', data)
}
// 回收订单--确认打款金额
const recoveryPay = data => {
  return post('/recovery-order/pay', data)
}
// 回收订单--拒绝回收
const recoveryRefuse = data => {
  return post('/recovery-order/refuse', data)
}
// 回收订单--回收确认
const recoveryConfirm = data => {
  return post('/recovery-order/confirm', data)
}
// 回收订单--退回寄件
const recoveryBack = data => {
  return post('/recovery-order/back', data)
}
// 回收订单-状态数量
const recoveryStatus = data => {
  return get('/recovery-order/status-count-list', data)
}
// 快递列表
const expressList = data => {
  return get('/recovery-order/express-list', data)
}

// 团购-快递列表
const getLogistList = data => {
  return post('/mercWebi/order/getLogistList', data)
}
// 团购-实物商品发货
const groupOrderSend = data => {
  return post('/mercWebi/order/groupOrderSend', data)
}
// 团购-实物商品签收
const groupOrderSignFor = data => {
  return post('/mercWebi/order/groupOrderSignFor', data)
}

// 抖音-团单可退商品
const getRefundableList = data => {
  return post('/dy/order/refundableList', data)
}

// 抖音-团单商家退款
const dyCancelOrder = data => {
  return post('/mercWebi/dy/order/mercCreateRefund', data)
}

// 抖音-团单商家取消预约订单
const cancelReservationOrder = data => {
  return post('/dy/order/mercCancelReservation', data)
}

export default {
  getGroupOrderList,
  queryOrderDetail,
  getSumOrdserStatus,
  queryCodeBookedInfo,
  refundGroupOrder,
  queryOrderPayList,
  insertOrderRemarke,
  modifyOrderRemarke,
  deleteOrderRemarke,
  downloadGroupOrderList,
  queryTakeoutList,
  addWorker,
  queryTakeOutSums,
  queryWashOrderList,
  queryWashMeiTuanOrderList,
  queryWashOrderDetail,
  updateorderfulfillinfo,
  washOrderUpdateAddress,
  queryList,
  queryDownList,
  pickingOrderInfo,
  excelWashOrderList,
  evalOrderList,
  evalOrderStatusCount,
  evalTradeRecord,
  evalOrderDetail,
  finalEval,
  firstEval,
  recoveryList,
  recoveryDetail,
  recoveryRefuse,
  recoveryPay,
  recoveryConfirm,
  recoveryBack,
  recoveryStatus,
  expressList,
  getLogistList,
  groupOrderSend,
  groupOrderSignFor,
  getRefundableList,
  dyCancelOrder,
  cancelReservationOrder
}
